import type { FC } from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import GallectionCoverDumbo from '@wix/da-shared-react/pkg/GallectionCoverDumbo';
import UknownDumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/Unknown';

import s from './PremiumGalleryThumb.scss';

const THUMB_HEIGHT = 40;
const THUMB_WIDTH = 64;

interface Props {
  gallery: PapiGallection;
}

const PremiumGalleryThumb: FC<Props> = ({ gallery }) => {
  if (!gallery.thumb) {
    return (
      <UknownDumbo
        className={s['dumbo']}
        width={THUMB_WIDTH}
        height={THUMB_HEIGHT}
      />
    );
  }
  return (
    <GallectionCoverDumbo
      className={s['dumbo']}
      gallection={gallery}
      width={THUMB_WIDTH}
      height={THUMB_HEIGHT}
    />
  );
};
PremiumGalleryThumb.displayName = 'PremiumGalleryThumb';

export default PremiumGalleryThumb;
